import axios, { AxiosInstance } from 'axios';
import axiosRetry, { IAxiosRetryConfig } from 'axios-retry';

const axiosRetryOptions: IAxiosRetryConfig = {
  retries: 10,
  retryCondition: (error) => {
    return error?.response?.status === 429;
  },
  retryDelay: (retryCount, error) => {
    const retryAfter = Number(
      error?.response?.headers['x-ratelimit-retryafter']
    );

    if (Number.isFinite(retryAfter) && retryAfter > 0) {
      return retryAfter * 1000 * Math.pow(2, retryCount);
    } else {
      return 1000;
    }
  },
};

export let chatAxios: AxiosInstance;

export function configure({
  appId,
  apiToken,
}: {
  appId: string;
  apiToken: string;
}) {
  const baseURL = `https://api-${appId}.sendbird.com`;

  chatAxios = axios.create({
    baseURL,
    headers: { 'Api-Token': apiToken },
  });

  axiosRetry(chatAxios, axiosRetryOptions);
}
